import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import { Card } from 'semantic-ui-react';
import moment from 'moment';
import { showPackage, deletePackage, updatePublish } from '../../api/packageApi';
import history from '../../history';
import { formatMoneyLegacy } from '../../utils/currency';

class PrivateTourDetails extends Component {
  state = { tour: null, fetchError: false };

  fetchTour = () => {
    const idx = this.props.match.params.idx;
    this.setState({ fetchError: false });
    showPackage(idx)
      .then((r) => this.setState({ tour: r.data, fetchError: false }))
      .catch(() => this.setState({ tour: null, fetchError: true }));
  };

  componentDidMount() {
    const idx = this.props.match.params.idx;
    const fromState = this.props.location.state && this.props.location.state.privateTour;
    if (fromState && fromState.idx === idx) {
      this.setState({ tour: fromState });
      this.fetchTour();
      return;
    }
    this.fetchTour();
  }

  destroy = (id) => {
    swal({ title: 'Are you sure?', text: 'This private tour will be deleted.', icon: 'warning', buttons: true, dangerMode: true })
      .then((ok) => {
        if (ok) {
          deletePackage(id)
            .then(() => { swal('Deleted', { icon: 'success' }); history.push('/admin/private_tours'); })
            .catch(() => swal('Delete failed', { icon: 'error' }));
        }
      });
  };

  publish = (shouldPublish) => {
    const { tour } = this.state;
    if (!tour) return;
    swal({ title: 'Are you sure?', text: `Publish/unpublish this private tour?`, icon: 'warning', buttons: true, dangerMode: true })
      .then((ok) => {
        if (ok) {
          updatePublish(tour.idx, shouldPublish)
            .then(() => { swal(`Private tour ${shouldPublish ? 'published' : 'unpublished'}`, { icon: 'success' }); this.fetchTour(); })
            .catch(() => swal('Update failed', { icon: 'error' }));
        }
      });
  };

  render() {
    const { tour, fetchError } = this.state;
    if (fetchError) {
      return (
        <div className="container p-4">
          <div className="alert alert-warning">Private tour not found or it has been deleted.</div>
          <Link to="/admin/private_tours" className="btn btn-outline-primary">Back to Private Tours</Link>
        </div>
      );
    }
    if (!tour) return <div className="container p-4">Loading…</div>;

    const fromTo = `${tour.origin || '—'} → ${tour.destination || '—'}`;

    return (
      <div className="container">
        <Card fluid>
          <Card.Content>
            <div className="d-flex justify-content-between">
              <h3 className="title">{tour.name || 'Private Tour'}</h3>
              <div>
                {tour.has_any_inquiry_or_booking ? (
                  <span className="text-muted small" title="Not available once anyone has inquired or booked">Edit / Delete locked</span>
                ) : (
                  <>
                    <Link to={{ pathname: `/admin/private_tour_form/${tour.idx}`, state: { privateTour: tour } }} className="btn btn-outline-primary">Edit</Link>
                    <span className="btn btn-outline-danger ml-2" onClick={() => this.destroy(tour.idx)}>Delete</span>
                  </>
                )}
              </div>
            </div>
            <Link to="/admin/private_tours" className="btn btn-outline-secondary btn-sm mt-2 mb-3">← Back to Private Tours</Link>

            <div className="list-view mt-3">
              <div className="list"><span className="label">From → To</span><span className="value">{fromTo}</span></div>
              <div className="list"><span className="label">Price</span><span className="value">{tour.price != null || tour.vendor_total_price != null ? formatMoneyLegacy(tour.vendor_total_price ?? tour.price, tour.currency_code || 'NPR') : '—'}</span></div>
              <div className="list"><span className="label">Published</span><span className="value">{String(!!tour.published)}</span></div>
            </div>

            {!tour.published && (
              <div className="mt-3">
                <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => this.publish(true)}>Publish private tour</button>
              </div>
            )}
            {tour.published && (
              <div className="mt-3">
                <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => this.publish(false)}>Unpublish private tour</button>
              </div>
            )}

            <div className="mt-4">
              <Link to="/admin/manage_private_tours" className="btn btn-outline-primary">Manage Private Tours (inquiries & bookings)</Link>
            </div>

            {tour.description && (
              <div className="mt-4">
                <h5 className="mb-2">Description</h5>
                <div className="text-muted" dangerouslySetInnerHTML={{ __html: tour.description }} />
              </div>
            )}
          </Card.Content>
        </Card>
      </div>
    );
  }
}

export default PrivateTourDetails;
